export { PaymentQR as PaymentQRModal } from './PaymentQR';
